/*
* @2023 jnakaso
*/

import firebaseClient from './firebase';
import { getStorage, ref, getBytes, uploadString } from "firebase/storage";

class LocalStorageService {

    storage = getStorage(firebaseClient);
    decoder = new TextDecoder("utf-8");

    async getInfoFile(fileName: string): Promise<string> {
        return fetch(`info/${fileName}`)
            .then((res) => res.text())
    }

    async getSeasonFile(season: number, fileName: string): Promise<string> {
        return fetch(`${season}/${fileName}`)
            .then((res) => res.text())
    }
}

class RemoteStorageService {

    storage = getStorage(firebaseClient);
    decoder = new TextDecoder("utf-8");

    async getInfoFile(fileName: string): Promise<string> {
        const fileRef = ref(this.storage, `info/${fileName}`);
        return getBytes(fileRef)
            .then(b => this.decoder.decode(b))

    }

    async getSeasonFile(season: number, fileName: string): Promise<string> {
        const fileRef = ref(this.storage, `${season}/${fileName}`);
        return getBytes(fileRef)
            .then(b => this.decoder.decode(b))
    }

    async uploadSeasonFile(season: number, fileName: string, contents: string): Promise<boolean> {
        const storage = getStorage();
        const storageRef = ref(storage, `${season}/${fileName}`);

        return uploadString(storageRef, contents)
            .then((snapshot) => {
                console.log('Uploaded a raw string!', snapshot);
                return true;
            });
    }

}

const storageService = (process.env.REACT_APP_IS_LOCAL && process.env.REACT_APP_IS_LOCAL === "true")
    ? new LocalStorageService()
    : new RemoteStorageService();

export { storageService };